import _ from 'lodash';
import { SECOND } from 'Utils/time';
import addRcuModal from './addRcu.modal.component';
import disableEventsModal from './disableEvents.modal.component';
import equipmentManagementModal from './equipmentManagement.modal.component';
import template from './equipmentTable.html';

/* @ngInject */
function EquipmentTableController(
  $q,
  $state,
  $uibModal,
  growl,
  EquipmentService,
  RcuService,
  EquipmentInfoService,
  RcuInfoService,
  ModalService,
  Organization,
  GroupService,
  SiteService,
  UserInfoService
) {
  const vm = this;
  let allEquipment = [];
  let fetchEquipmentPromise;
  const allColumns = [
    { field: 'MAPPED_eq.org', header: 'Org', type: 'text', wide: true },
    { field: 'MAPPED_eq.site', header: 'Site', type: 'text', wide: true },
    { field: 'MAPPED_rcu.name', header: 'RCU', type: 'text', wide: true },
    { field: 'name', header: 'Name', type: 'text', wide: true },
    { field: 'equipmentType', header: 'Type', type: 'text' },
    { field: 'id', header: 'Id', type: 'text', copyToClipboard: true },
    { field: 'MAPPED_eq.groups', header: 'Groups', type: 'object' },
    { field: 'groups', header: 'Groups Details', type: 'text' },
    { field: 'settings.ip', header: 'IP', type: 'text' },
    { field: 'settings.port', header: 'Port', type: 'text' },
    { field: 'settings.protocol', header: 'Protocol', type: 'text' },
    { field: 'settings.externalIp', header: 'External Address', type: 'text' },
    { field: 'settings.externalPort', header: 'External Port', type: 'text' },
    { field: 'settings.timezone', header: 'Timezone', type: 'text' },
    { field: 'settings.latitude', header: 'Latitude', type: 'text' },
    { field: 'settings.longitude', header: 'Longitude', type: 'text' },
    { field: 'dashboards', header: 'Dashboards', type: 'text' },
    { field: 'settings.continuousVideo', header: 'Continuous Video', type: 'text' },
    { field: 'settings.nvr', header: 'NVR', type: 'text' },
    { field: 'settings.rtspStream', header: 'Rtsp Stream', type: 'text' },
    { field: 'settings.doorName', header: 'Door Name', type: 'text' },
    { field: 'settings.classify', header: 'AI Configuration', type: 'text' },
    { field: 'settings.aiModels', header: 'AI Models', type: 'text' },
    { field: 'settings.mmc', header: 'SOC', type: 'boolean' },
    { field: 'settings.iccid', header: 'ICCID', type: 'string' },
    { field: 'settings.macAddress', header: 'Mac Address', type: 'text' },
    { field: 'settings.serial', header: 'Serial', type: 'text' },
    { field: 'settings.hwVersion', header: 'Hw Version', type: 'text' },
    { field: 'settings.battery', header: 'Battery', type: 'text' },
    { field: 'createdAt', header: 'Created At', type: 'date' },
    { field: 'updatedAt', header: 'Updated At', type: 'date' },
    { field: 'org', header: 'Org Id', type: 'text', copyToClipboard: true },
    { field: 'MAPPED_rcu.ip', header: "RCU's Ip", type: 'text' },
    { field: 'MAPPED_rcu.port', header: "RCU's Port", type: 'text' },
    { field: 'MAPPED_rcu.state', header: "RCU's State", type: 'text' },
    { field: 'MAPPED_rcu.version', header: "RCU's Version", type: 'text' },
    { field: 'MAPPED_rcu.org', header: "RCU's Org", type: 'text' },
    { field: 'MAPPED_rcu.kind', header: "RCU's Kind", type: 'text' },
    { field: 'MAPPED_rcu.synchronized', header: "RCU's Synchronized", type: 'text' },
    { field: 'MAPPED_rcu.deleted', header: "RCU's Deleted", type: 'text' },
    { field: 'MAPPED_rcu.createdAt', header: "RCU's Created At", type: 'date' },
    { field: 'MAPPED_rcu.updatedAt', header: "RCU's Updated At", type: 'date' },
    { field: 'MAPPED_rcu.syncDate', header: "RCU's Sync Date", type: 'date' },
    { field: 'MAPPED_rcu.lastDisconnect', header: "RCU's Last Disconnect", type: 'date' },
    { field: 'MAPPED_rcu.id', header: "RCU's Id", type: 'text', copyToClipboard: true },
    { field: 'MAPPED_rcu.orgId', header: "RCU's Org Id", type: 'text', copyToClipboard: true },
    { field: 'MAPPED_rcu.connectionType', header: "RCU's Connection Type", type: 'text' },
    { field: 'MAPPED_rcu.lastConnect', header: "RCU's Last Connect", type: 'date' },
    { field: 'MAPPED_rcu.build.family', header: "RCU's Build Family", type: 'text' },
    { field: 'MAPPED_rcu.build.model', header: "RCU's Build Model", type: 'text' },
  ];

  const columnsToExclude = new Set([
    'equipment.settings.continuousVideo',
    'equipment.settings.nvr',
    'equipment.settings.rtspStream',
    'equipment.settings.doorName',
    'equipment.settings.classify',
    'equipment.settings.aiModels',
    'equipment.settings.macAddress',
    'equipment.settings.serial',
    'equipment.settings.hwVersion',
    'equipment.settings.battery',
    'equipment.createdAt',
    'equipment.updatedAt',
    'MAPPED_rcu.ip',
    'MAPPED_rcu.port',
    'MAPPED_rcu.state',
    'MAPPED_rcu.version',
    'MAPPED_rcu.org',
    'MAPPED_rcu.kind',
    'MAPPED_rcu.synchronized',
    'MAPPED_rcu.deleted',
    'MAPPED_rcu.createdAt',
    'MAPPED_rcu.updatedAt',
    'MAPPED_rcu.syncDate',
    'MAPPED_rcu.lastDisconnect',
    'MAPPED_rcu.id',
    'MAPPED_rcu.orgId',
    'MAPPED_rcu.connectionType',
    'MAPPED_rcu.lastConnect',
    'MAPPED_rcu.build.family',
    'MAPPED_rcu.build.model'
  ]);

  vm.allRcus = [];

  vm.$onInit = init;
  vm.$onDestroy = $onDestroy;
  vm.selectRcu = selectRcu;
  vm.syncRcu = syncRcu;
  vm.syncRcuModal = syncRcuModal;
  vm.powerCycleCellular = powerCycleCellular;
  vm.powerCycleEquipment = powerCycleEquipment;
  vm.deleteRcu = deleteRcu;
  vm.deleteRcuModal = deleteRcuModal;
  vm.deleteEquipment = deleteEquipment;
  vm.deleteEquipmentModal = deleteEquipmentModal;
  vm.disableEvents = disableEvents;
  vm.openRcuModal = openRcuModal;
  vm.openEquipmentModal = openEquipmentModal;
  vm.handleAddEqClicked = handleAddEqClicked;
  vm.saveEquipment = saveEquipment;
  vm.handleDeleteEquipment = handleDeleteEquipment;
  vm.handleOpenCameraClicked = handleOpenCameraClicked;
  vm.fetchEquipment = fetchEquipment;


  async function init() {

    vm.sites = _.keyBy(await SiteService.get(), 'id');
    vm.organizations = await Organization.model;
    vm.sortedOrganizations = vm.organizations.array.sort((a, b) => a.name.localeCompare(b.name));
    vm.globalFilterFields = ['name', 'equipmentType', 'id', 'org', 'site', 'rcu', 'MAPPED_rcu.name', 'MAPPED_eq.org'];

    RcuInfoService.getAllRcus()
      .then((foundRcus) => {
        vm.allRcus = foundRcus;
      });

    EquipmentInfoService.setNeed('equipment_management');
    fetchEquipment();

    GroupService.getGroups().then((data) => {
      vm.subGroups = data;
    });

    vm.equipmentTableOptions = {
      showAdd: false,
      showColumnsMenu: true,
      actions: false,
      columnMenu: true,
      paginator: true,
      search: true,
      sortable: true,
      userRole: UserInfoService.isCurrentUserExactlyAdmin() ? 'admin' : 'notAdmin'
    };

    if (UserInfoService.isCurrentUserPartner() || UserInfoService.isCurrentUserSuperAdmin()) {
      RcuInfoService.subscribeToAdmin();
    }

  }

  function fetchEquipment(fresh) {
    if (fresh) {
      EquipmentInfoService.currentlyPopulatedWith = '';
    }
    fetchEquipmentPromise = EquipmentInfoService.getAllEquipments()
      .then((foundEquipment) => {
        allEquipment = foundEquipment;
        updateGridWithEquipment();
      });
  }

  function handleAddEqClicked($event) {
    $state.go('admin.equipment.new', { rcu: $event.rcu.id });
  }

  async function selectEquipment(id) {
    await $q.resolve(fetchEquipmentPromise);
    vm.currentEquipment = _.find(allEquipment, { id });
  }

  function getRcuSsh(rcu) {
    if (rcu.ip.startsWith('100.86')) {
      return `ssh intelliadmin@${rcu.ip}`;
    }
    if (rcu.ip && rcu.port) {
      const user = _.includes(_.get(rcu, ['version', 'distro']), 'Raspbian GNU/Linux 7') ? 'pi' : 'petrocloud';
      const minusPort = 58;
      rcu.sshPort = parseInt(rcu.port, 10) - minusPort;
      return `ssh -p ${rcu.sshPort} ${user}@${rcu.ip}`;
    }
    return '';
  }

  /**
   * Select an RCU
   * (Reinitialize the grid with the associated equipment)
   * If passed RCU is already selected, it is deselected* and the grid inits with all equipment
   *
   * @param {object | string} [rcu=vm.currentEquipment.rcu] Literal or an ID
   * @returns {Promise<undefined>}
   */
  async function selectRcu(rcu = vm.currentEquipment.rcu) {
    if (!_.isObject(rcu)) {
      rcu = await RcuInfoService.getRcuById(rcu);
    }
    if (!rcu) {
      // assuming user doesn't have access to the RCU, only the equipment
      vm.currentRcu = undefined;
      vm.currentEquipmentRcu = undefined;
      return;
    }

    // Deselection
    if (vm.currentRcu && vm.currentRcu.id === rcu.id) {
      vm.currentRcu = undefined;
      vm.currentEquipmentRcu = undefined;
      $state.go('admin.equipment');
    } else {
      vm.currentRcu = {
        ...rcu,
        ssh: getRcuSsh(rcu)
      };
      vm.currentEquipmentRcu = vm.currentRcu;

      // Deselect equipment if not associated with our RCU
      if (!rcu.equipment.includes(vm.currentEquipment?.id)) {
        vm.currentEquipment = undefined;
        $state.go('admin.equipment');
      }
    }
    return vm.currentRcu ?
      updateGridWithRCU() :
      updateGridWithEquipment();
  }

  function syncRcu(forceSync) {
    let growlMessage = growl.info('Attempting to sync rcu.', { disableCloseButton: true });
    return RcuService.syncRcus(vm.currentRcu.id, forceSync)
      .then(({ data }) => {
        growlMessage.destroy();
        growlMessage = growl.success('Rcu successfully synced!');
        if (data.deleted && data.synchronized) {
          vm.currentRcu = null;
        }
      })
      .catch((err) => {
        growlMessage.destroy();
        growlMessage = growl.error(_.get(err, 'error', err), { title: 'Could not sync rcu: ' });
        return $q.reject();
      });
  }

  function syncRcuModal(rcu) {
    vm.selectRcu(rcu);
    return ModalService.confirmationModal({
      modalTitle: 'Sync Rcu',
      optionalWarning: 'This will overwrite all of the current settings on the RCU. Do this with caution.',
      selectionCriteria: `The RCU "${vm.currentRcu.name}" will be synced.`,
      additionalOptionMessage: 'Force sync upon failure',
      onConfirm: syncRcu
    });
  }

  function suggestSyncModal() {
    return ModalService.confirmationModal({
      modalTitle: 'Sync RCU',
      optionalWarning: 'You just deleted an equipment node from the platform. ' +
        'This change will not be reflected without a sync',
      selectionCriteria: `The RCU "${vm.currentRcu.name}" will be synced.`,
      onConfirm: syncRcu,
      danger: false,
    });
  }

  function powerCycleCellular(rcu) {
    vm.selectRcu(rcu);
    if (_.get(vm.currentRcu, 'settings.powerCycling') === 'none') {
      return powerCycleNotSet('Cellular')
        .then(() => {
          openRcuModal(rcu, true);
        });
    }
    let growlMessage;
    return ModalService.confirmationModal({
      modalTitle: 'Confirm',
      optionalWarning: 'This will attempt to power cycle the RCU switch. ' +
        'If misconfigured or disabled, this will not work',
      selectionCriteria: `The RCU "${vm.currentRcu.name}" will power cycle its switch.`
    })
      .then(() => {
        growlMessage = growl.info('Sending request to power cycle…', { disableCloseButton: true });
        return RcuService.powerCycleCellular(vm.currentRcu.id);
      })
      .then(() => {
        growlMessage.destroy();
        growlMessage = growl.success('The request to power cycle was successfully completed');
      })
      .catch((err) => {
        growlMessage.destroy();
        growlMessage = growl.error(err, { title: 'Request could not be completed:' });
      });
  }

  function powerCycleEquipment(rcu) {
    vm.selectRcu(rcu);
    if (_.get(vm.currentRcu, 'settings.powerCycling') === 'none') {
      return powerCycleNotSet('Equipment')
        .then(() => {
          openRcuModal(rcu, true);
        });
    }
    let growlMessage;
    return ModalService.confirmationModal({
      modalTitle: 'Confirm',
      optionalWarning: 'This will attempt to power cycle the equipment connected to this RCU. ' +
        'If misconfigured or disabled, this will not work',
      selectionCriteria: `The RCU "${vm.currentRcu.name}" will power cycle the computing unit.`,
      onConfirm: () => {
        growlMessage = growl.info('Sending request to power cycle…', { disableCloseButton: true });
        RcuService
          .powerCycleEquipment(vm.currentRcu.id)
          .then(() => {
            growlMessage.destroy();
            growlMessage = growl.success('The request to power cycle was successfully completed');
          })
          .catch((err) => {
            growlMessage.destroy();
            growlMessage = growl.error(err, { title: 'Request could not be completed:' });
          });
      }
    });
  }

  function powerCycleNotSet(type) {
    return ModalService.confirmationModal({
      modalTitle: `Power Cycle ${type}`,
      optionalWarning: 'Power cycling not configured for this RCU.',
      selectionCriteria: `Click "Confirm Action" to edit RCU ${vm.currentRcu.name} and set a power cycling method.`
    });
  }

  function deleteRcu() {
    let growlMessage = growl.info('Attempting to delete RCU', { disableCloseButton: true });
    return RcuService
      .deleteRcu(vm.currentRcu.id)
      .then(() => {

        growlMessage.destroy();
        _.forEach(vm.currentRcu.equipment, (id) => {
          const foundEquipInd = _.findIndex(allEquipment, ['id', id]);
          if (foundEquipInd > -1) {
            allEquipment.splice(foundEquipInd, 1);
          }
        });

        return ModalService.confirmationModal({
          modalTitle: 'Sync Rcu',
          optionalWarning: 'You just deleted the RCU from the platform. ' +
            'You should perform a Sync in order to clear the RCU local database',
          selectionCriteria: `The RCU "${vm.currentRcu.name}" will be synced.`,
          additionalOptionMessage: 'Force sync upon failure'
        })
          .then((forceSync) => {
            growlMessage = growl.info('Attempting to sync rcu.', { disableCloseButton: true });
            return RcuService.syncRcus(vm.currentRcu.id, forceSync);
          })
          .then(() => {
            growlMessage.destroy();
            growlMessage = growl.success('Rcu successfully synced!');
          })
          .catch((err) => {
            growlMessage.destroy();
            growlMessage = growl.error(err, { title: 'Something went wrong:' });
          })
          .finally(() => {
            vm.currentRcu.equipment = [];
            vm.currentRcu = null;
            vm.currentEquipmentRcu = null;
            updateGridWithEquipment();
          });
      })
      .catch((err) => {
        growlMessage.destroy();
        growlMessage = growl.error(err, { title: 'Could not delete RCU' });
      });
  }

  function deleteRcuModal(rcu) {
    vm.selectRcu(rcu);
    return ModalService.confirmationModal({
      modalTitle: 'Delete RCU',
      optionalWarning: `
        This will delete the RCU from the platform.
        This change will not be reflected on the RCU without a sync.
      `,
      selectionCriteria: `The RCU "${vm.currentRcu.name}" will be removed.`,
      onConfirm: deleteRcu
    });
  }

  async function deleteEquipment(eq) {
    const { id } = eq;

    let growlMessage = growl.info('Attempting to delete equipment.', { disableCloseButton: true });
    return EquipmentService
      .deleteEquipment(id)
      .then(() => {
        _.remove(allEquipment, { id });

        growlMessage.destroy();
        growlMessage = growl.success('Equipment successfully deleted!');

        if (vm.currentRcu) {
          updateGridWithRCU();
        } else {
          updateGridWithEquipment();
        }
        if (vm.currentRcu?.kind === 'PHYSICAL') {
          suggestSyncModal();
        } // TODO: Make sure virtual RCUs update in view too
      })
      .catch((err) => {
        growlMessage.destroy();
        growlMessage = growl.error(err, { title: 'Could not delete equipment: ' });
      });
  }

  function deleteEquipmentModal(eq) {
    return ModalService.confirmationModal({
      modalTitle: 'Delete Equipment',
      optionalWarning: 'This will delete the equipment from the platform. ' +
        'This change will not be reflected on the RCU without a sync.',
    }).then(() => deleteEquipment(eq));
  }

  function handleMultipleActions(equipment, action, growlInfo, growlError, growlSuccess, postAction) {
    let growlMessage = growl.info(growlInfo, {
      disableCloseButton: true
    });

    const actionPromises = [];

    equipment.forEach(eq => actionPromises.push(action(eq)));

    return Promise.allSettled(actionPromises)
      .then((results) => {
        const errors = [];
        results.forEach((result) => {
          if (result.status === 'rejected') {
            errors.push(result.reason?.data?.error);
          }
        });
        growlMessage.destroy();

        if (errors.length > 1) {
          growlMessage = growl.error(JSON.stringify(errors), { title: growlError }, { ttl: 10000 });
        } else {
          growlMessage = growl.success(growlSuccess);
          if (_.isFunction(postAction)) {
            postAction();
          }
          growlMessage.destroy();
          updateGridWithEquipment();
        }
      })
      .catch((err) => {
        growlMessage.destroy();
        growlMessage = growl.error(err.message, { title: 'Server error' }, { ttl: 10000 });
      });
  }

  function handleDeleteEquipment(eqToDelete) {
    if (eqToDelete.length > 1) {
      return handleMultipleActions(eqToDelete,
        ({ id }) => EquipmentService.deleteEquipment(id),
        'Deleting equipment...',
        'Error while deleting:',
        'Equipment successfully deleted!',
        () => {
          eqToDelete.forEach((eq) => {
            _.remove(allEquipment, { id: eq.id });
          });
        });
    }
    return deleteEquipmentModal(eqToDelete);
  }

  async function disableEvents($event) {
    // await selectEquipment($event.id);
    const modalInstance = $uibModal.open({
      ...disableEventsModal,
      size: 'lg',
      resolve: {
        selectedEquipment() {
          // const equipmentToDisable = {};
          // equipmentToDisable[vm.currentEquipment.id] = vm.currentEquipment;
          return $event;
        }
      }
    });

    modalInstance.result
      .then((updatedEquipment) => {
        _.forEach(updatedEquipment, (eq) => {
          EquipmentInfoService.updateEquipment(eq);
        });
        // update grid data
        if (vm.currentRcu) {
          updateGridWithRCU();
        } else {
          updateGridWithEquipment();
        }
      });
  }

  // ///////////////////////////////////////////// //
  // scope and instance controllers for the modals //
  // ///////////////////////////////////////////// //

  // instance controller and scope for the rcu modal
  function openRcuModal($event, edit) {
    vm.selectRcu($event);
    $uibModal.open({
      ...addRcuModal,
      size: 'ex-lg',
      resolve: {
        currentRcu() {
          return edit ? vm.selectRcu($event) : false;
        }
      }
    }).result.then((newRcu) => {
      if (newRcu) {
        vm.selectRcu(newRcu);
      }
    });
  }


  async function openEquipmentModal(eq, editing) {
    // const { id } = eq.id || $stateParams;
    vm.selectRcu(eq);

    editing && !vm.currentEquipment && await selectEquipment(eq.id);
    try {
      const equipment = await $uibModal.open({
        ...equipmentManagementModal,
        size: 'lg',
        resolve: {
          currentRcu() {
            return vm.currentRcu ||
              vm.currentEquipmentRcu ||
              // Monkey patch for cases where partner does not have RCU access
              { name: '', id: vm.currentEquipment.rcu }
            ;
          },
          async equipment() {
            return editing ? EquipmentInfoService.getFreshEquipment(eq.id) : false;
          }
        }
      }).result;

      // ! Handle only new equipment here, edits should propagate from reference
      const equipmentParent = _.find(vm.allRcus, { id: equipment.rcu });
      if (equipmentParent) {
        equipmentParent.synchronized = false;
        // TODO: We should probably rely on socket events here instead
        if (!equipmentParent.equipment) {
          equipmentParent.equipment = [equipment.id]; // ! Remove once RCUs are init with empty arrays
        } else if (!equipmentParent.equipment.includes(equipment.id)) {
          equipmentParent.equipment.push(equipment.id);
        }
      }


      if (!editing) {
        const newEquipment = await EquipmentInfoService.getFullEquipment(equipment.id);
        allEquipment.push(newEquipment); // TODO: AllEquipment should be $watched and update by itself
      }
    } catch (err) {
      ['backdrop click', 'closed'].includes(err) || console.error(err);
      _.delay(() => {
        const alreadyNavigated = !['admin.equipment.new', 'admin.equipment.edit'].includes($state.current.name);
        alreadyNavigated || window.history.back();
        // Wait is needed to allow $state to update from external navigation
      }, SECOND / 4);
    }
  }

  function updateGridWithEquipment(equipment = allEquipment) {
    RcuService.getRcuList()
      .then(({ data: userRCUs }) => {
        vm.finalEquipment = _.map(equipment, (eq) => {
          const populatedEq = _.cloneDeep(eq);
          // eslint-disable-next-line angular/no-private-call
          delete populatedEq.$$hashKey;
          let eqRcu = _.cloneDeep(_.find(userRCUs, rcu => rcu.id === eq.rcu));

          // Populate function
          if (eqRcu) {
            eqRcu = _.merge(
              {},
              eqRcu,
              { version: eqRcu.version?.dnversion },
              { org: _.get(vm.organizations.byId, [eqRcu.org, 'name']) },
              { orgId: _.get(vm.organizations.byId, [eqRcu.org, 'id']) },
            );
            _.set(populatedEq, 'MAPPED_rcu', eqRcu);
          }

          const eqPopulated = {
            org: _.get(vm.organizations.byId, [populatedEq.org, 'name']),
            site: _.get(vm.sites, [populatedEq.site, 'name']),
          };
          _.set(populatedEq, 'MAPPED_eq', eqPopulated);

          if (populatedEq.dashboards) {
            populatedEq.dashboards.toString = () =>
              _.reduce(populatedEq.dashboards, (acc, { name }) => `${acc}• ${name}\n`, '');
          }
          if (populatedEq.groups) {
            populatedEq.groups.toString = () =>
              _.reduce(populatedEq.groups, (acc, { name }) => `${acc}• ${name}\n`, '');
          }
          EquipmentInfoService.getHoursRemaining(populatedEq);
          return populatedEq;
        });

        vm.columns = _.cloneDeep(allColumns);
        vm.selectedColumns =  allColumns.filter(col => !columnsToExclude.has(col.field));
      })
      .catch((err) => {
        console.error(err);
      });
  }

  /**
   * @param {object} [rcu] An RCU model
   * @param {string[]} rcu.equipment IDs to populate
   * @param {boolean} [refresh] Should fetch fresh data?
   * @returns {undefined}
   */
  async function updateGridWithRCU(rcu = vm.currentRcu, refresh = false) {
    const { equipment: ids } = rcu;
    const equipment = refresh ?
      await EquipmentInfoService.getFreshEquipment(ids) :
      await EquipmentInfoService.getEquipmentById(ids);
    return $q.resolve(updateGridWithEquipment(equipment));
  }

  function saveEquipment(eqToSave) {
    return handleMultipleActions(eqToSave, eq => EquipmentInfoService.editEquipment(eq),
      'Saving equipment...',
      'Error while saving:',
      'Equipment successfully saved!');
  }

  function handleOpenCameraClicked(eq) {
    if (_.has(eq, ['settings', 'externalIp']) &&
      _.has(eq, ['settings', 'externalPort'])) {
      const eqUrl = `${eq.settings.protocol || 'http'}://${eq.settings.externalIp}:${eq.settings.externalPort}/`;
      window.open(eqUrl, '_blank').focus();
    }
  }

  function $onDestroy() {
    RcuInfoService.unsubscribeToAdmin();
  }
}

export default {
  name: 'equipmentTableComponent',
  template,
  controller: EquipmentTableController,
  bindings: {
    allOrgs: '<'
  }
};
